export default __webpack_public_path__ + "static/media/footer-phone.4d7e489f.png";